import styled from "styled-components";

export const FormHead = styled.div`
  padding-bottom: 24px;
  .heading6 {
    color: ${(props) => props.theme.colorlightblack};
    padding-bottom: 7px;
  }
`;
export const FormBody = styled.div`
  margin-bottom: 184px;
  max-width: 790px;
  .themecardwrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap; 
    .ant-radio-button-wrapper {
      background: transparent;
      border: 1px solid transparent;
      width: 100%;
    }
    .ant-radio-button-wrapper-checked {
      border: 2px solid ${(props) => props.theme.primary};
    }
  }

  .cardbtn {
    padding: 0;
    border: none;
    height: auto;
    margin: 15px 0;
  }

  .themecard {
    max-height: 100%;
    overflow: unset;

    .ant-card-body {
      padding: 0;
    }
    .themepreview {
      text-align: center;
    }
  }
`;
export const CardHead = styled.div`
  background-color: ${(props) => props.theme.bgcolordlightblue};
  padding: 16px 16px 15px;
  border-radius: 10px 10px 0px 0px;
  display: flex;
  align-items: center;
  gap: 10px;
  align-items: center;
  .activebox {
    background: ${(props) => props.theme.primary};
    border-radius: 35px;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    color: ${(props) => props.theme.textcolordwhite3};
    padding: 3px 10px;
    position: absolute;
    right: 10px;
  }
`;
export const CardBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const ParaSm = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.colorbluegrey};
`;
